<template>
    <v-form>
        <v-container>
            <v-layout justify-center>
                <h2>Registro de Usuario</h2>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-text-field
                        required 
                        v-model="register.clientCode"
                        placeholder="Código Administración"
                        @change="loadStructures"
                        @input="$v.register.clientCode.$touch()"
                        :error-messages="errors.clientCode"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field
                        required 
                        v-model="register.name"
                        placeholder="Nombre Completo"
                        @input="$v.register.name.$touch()"
                        :error-messages="errors.name"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field
                        required 
                        v-model="register.document"
                        placeholder="Documento de identidad"
                        @input="$v.register.document.$touch()"
                        :error-messages="errors.document"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field
                        required 
                        v-model="register.email"
                        placeholder="E-mail"
                        @input="$v.register.email.$touch()"
                        :error-messages="errors.email"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field
                        required 
                        v-model="register.structure"
                        placeholder="Torre - Apto / Casa / Oficina / Área"
                        @input="$v.register.structure.$touch()"
                        :error-messages="errors.structure"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-menu
                        :close-on-content-click="false"
                        v-model="birthDateMenu"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                    >
                        <v-text-field
                            required
                            slot="activator"
                            :value="formatedDate"
                            label="Fecha de nacimiento"
                            prepend-icon="event"
                            readonly
                            :error-messages="errors.birthDate"
                        ></v-text-field>
                        <v-date-picker v-model="register.birthDate" @input="birthDateMenu = false"></v-date-picker>
                    </v-menu>
                </v-flex>
                <v-flex xs12>
                    <v-checkbox
                        v-model="register.optIn"
                        label="Acepto las politicas de tratamiento de datos"
                        value="1"
                    ></v-checkbox>
                </v-flex>
                <v-flex xs12 class="text-xs-center">
                    <small><a href="http://www.seguridadshatter.com/politica-datos-shatter.pdf" target="_blank">Ver politicas</a></small>
                </v-flex>
                <v-flex xs12>
                    <v-btn color="primary" block @click="registerUser" :disabled="!register.optIn.length || inProgress">Registrarme</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>
<script>
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';
import authRepository from '../../../repositories/auth.repository';
export default {
    data(){
        return {
            register: {
                clientCode: '',
                name: '',
                document: '',
                email: '',
                birthDate: '',
                structure: '',
                optIn: []
            },
            structures: [],
            birthDateMenu: false
        }
    },
    validations: {
        register: {
            clientCode: {required, minLength: minLength(4), maxLength: maxLength(4)},
            name: {required},
            document: {required},
            email: {required, email},
            birthDate: {required},
            structure: {required}
        }
    },
    computed: {
        formatedDate() {
            if(!this.register.birthDate) return '';
            return moment(this.register.birthDate).format('D/M/Y');
        },
        errors() {
            return {
                clientCode: this.$v.register.clientCode.$error? ['Debe escribir el código de 4 dígitos proporcionado por la administración']: [],
                name: this.$v.register.name.$error? ['Debe escribir nombre completo']: [],
                document: this.$v.register.document.$error? ['Debe escribir documento de identificación']: [],
                email: this.$v.register.email.$error? ['Debe escribir el E-mail']: [],
                birthDate: this.$v.register.birthDate.$error? ['Debe seleccionar la fecha de nacimiento']: [],
                structure: this.$v.register.structure.$error? ['Debe seleccionar la estructura']: [],
            }
        }
    },
    methods: {
        loadStructures() {
        },
        registerUser(){
            this.$v.$touch();

            if(this.$v.$invalid) return;

            this.startProcessing();

            const ar = {...authRepository};
            ar.registerUser(this.register)
                .then(resp => {
                    this.stopProcessing();
                    const status = resp.data;

                    if(!!status.status){
                        toastr.success('Registro exitoso, la administración le notificará cuando su usuario sea activado', {
                            timeout: 6000
                        });
                        this.clearForm();
                        this.$router.push({ name: 'login' });
                    } else {
                        toastr.error(status.msg);
                    }
                })
                .catch(error => {
                    this.stopProcessing();
                    toastr.error('Error en el registro');
                });
        },
        clearForm() {
            Object.keys(this.register).map(key => this.register[key] = '');
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/Login/Register/Register.vue